import React, { Component } from "react";
import { connect } from "react-redux";
import {
  setCurrentNavPage,
  setSlideCompositionLabel,
  setLayout,
  setFondColor,
  setBackgroundComponent,
  setSlideId,
  addComponent,
  setSideBar,
  setSelectedComponent,
  addComponentLabel,
  addComponentIndicator,
  addComponentType,
  initSlideComposition,
  addNumberOfYears,
  initComponentConfig,
  setComponent,
  setComponentAction,
  setSelectedCase,
  initComponentAction,
  addMinValue,
  addMaxValue,
  addAnnexeCategory,
  configNbrYear,
  setIndicators,
  setSlideAction,
  AddExplanation,
  addExplanationContent,
  setSelectedIndicatorExplanation,
  setSlideComponentLabels,
  setSlideCompositionIsPublic,
  setSlideIsEditable
} from "Actions";
import { onSuccess, onError } from "Utils";
import SimplePageHeader from "../Common/SimplePageHeader/SimplePageHeader";
import _ from "i18n";
import styles from "./SlideCompositionPage.local.scss";
import { push } from "react-router-redux";
import SlideDisposition from "./SlideDisposition";
import SlideConfigurationPage from "./SlideConfigurationPage";
import ComponentList from "./ComponentList";
import ComponentConfiguration from "./ComponentConfiguration/ComponentConfiguration";
import {
  fetchIndicators,
  fetchSupportedIndicatorVars,
  saveSlideComposition,
  fetchSlide,
  fetchEnabledAnnexeCategories,
  fetchComments,
  fetchIndicatorsExplanation,
  saveIndicatorsExplanation
} from "Thunks";
import NumberOfYearsComponentConfiguration from "./ComponentConfiguration/NumberOfYearsComponentConfiguration";
import MultiIndicatorComponentConfiguration from "./ComponentConfiguration/MultiIndicatorComponentConfiguration";
import ShowSlideModal from "./ShowSlideModal";
import BarometerConfiguration from "./ComponentConfiguration/BarometerConfiguration";
import { ModalConfirm } from "tamtam-components";
import classnames from "classnames";
import clonedeep from "lodash.clonedeep";
import { Switch, Tooltip } from "antd";

class SlideCompositionPage extends Component {
  slideId;

  constructor(props) {
    super(props);
    this.state = {
      edited: false,
      showSlideModal: false,
      Indicator: [],
      explanationModal: false,
      slideIndicators: [],
      isOpenModal: false,
      isOpenModalDelete: false,
      selectedCase: null,
      saveComponent: false,
      labelsForm: {
        fr: "",
        en: "",
        nl: ""
      },
      componentLabels: {
        fr: "",
        en: "",
        nl: ""
      },
      privacyState: false
    };
    let { id } = this.props.match.params;
    this.slideId = id;
  }

  componentWillMount() {
    const { dispatch, lng, organizationUen } = this.props;
    dispatch(fetchIndicators());
    dispatch(fetchComments(organizationUen));
    // dispatch(fetchAvailableSlide());
    dispatch(fetchIndicatorsExplanation(organizationUen));
    dispatch(fetchSupportedIndicatorVars());
    dispatch(fetchEnabledAnnexeCategories({ lng }));
  }
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(setCurrentNavPage("DASHBOARD_PAGE_COMPOSITION"));
    dispatch(initSlideComposition());
    if (this.slideId) {
      // get the slide in order to update
      dispatch(setSlideAction("update"));
      dispatch(fetchSlide(this.slideId));
    } else {
      // creating a new slide
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { slideFetched, dispatch, composition } = this.props;
    if (prevProps.slideFetched !== slideFetched) {
      this.setState({
        privacyState: composition.isPublic
      });
      if (this.slideId) {
        dispatch(setSlideCompositionLabel(this.props.composition.labels));
        this.setState({
          labelsForm: this.props.composition.labels
        });
      } else {
        // creating a new slide
      }
    }
  }

  handlerOpenIndicatorsExplanationModal = () => {
    const {
      composition: { SlideIndicators }
    } = this.props;
    this.setState({
      slideIndicators: SlideIndicators
    });
    var modal = document.getElementById("myModal");
    modal.style.display = "block";
  };

  handlerInputExplanationChange = event => {
    const { dispatch } = this.props;
    dispatch(addExplanationContent(event.target.value));
  };

  handlerIndicatorsExplanation = (
    isBarometerConfig = false,
    isTableConfig = false
  ) => {
    const {
      minValue,
      maxValue,
      nbrOfYear,
      dispatch,
      annexeCategory,
      composition: { SlideIndicators }
    } = this.props;
    const { explanationModal } = this.state;
    let conf = {};
    if (SlideIndicators.length === 0) {
      onError("choisir indicateur");
    } else {
      if (explanationModal === true) {
        if (isBarometerConfig) {
          conf = {
            minValue,
            maxValue,
            annexeAttachmentCategory: annexeCategory
          };
        } else if (isTableConfig) {
          conf = {
            nbrOfYears: nbrOfYear,
            annexeAttachmentCategory: annexeCategory,
            hasExplanation: false
          };
        } else if (isBarometerConfig === false && isTableConfig === false) {
          conf = {
            annexeAttachmentCategory: annexeCategory
          };
        }
        dispatch(addNumberOfYears(conf));
        this.setState({
          explanationModal: false,
          slideIndicators: SlideIndicators
        });
      } else {
        if (isBarometerConfig) {
          conf = {
            minValue,
            maxValue,
            annexeCategory,
            hasExplanation: true
          };
        } else if (isTableConfig) {
          conf = {
            nbrOfYears: nbrOfYear,
            annexeAttachmentCategory: annexeCategory,
            hasExplanation: true
          };
        } else if (isBarometerConfig === false && isTableConfig === false) {
          conf = {
            annexeAttachmentCategory: annexeCategory,
            hasExplanation: true
          };
        }
        dispatch(addNumberOfYears(conf));
        this.setState({
          explanationModal: true,
          slideIndicators: SlideIndicators
        });
      }
    }
  };

  handleCancelShowSlideModal = () => {
    this.setState({
      showSlideModal: false
    });
  };
  handleDisplaySlideModal = () => {
    this.setState({
      showSlideModal: true
    });
    this.props.dispatch(fetchSupportedIndicatorVars(this.props.slideId));
  };
  handlerInputChange = (lng, event) => {
    const { dispatch } = this.props;
    let { labelsForm } = this.state;

    let labels = clonedeep(labelsForm);

    labels[lng] = event.target.value;

    this.setState({
      labelsForm: labels
    });
    dispatch(setSlideCompositionLabel(labels));
    this.setState({ edited: true });
  };
  handleChangeSideBar = (sideBar, selectedComponent) => {
    const { dispatch } = this.props;
    dispatch(setSideBar(sideBar));
    dispatch(initComponentAction("ADD"));
    this.handleChangeSelectedComponent(selectedComponent);
  };
  handleChangeSelectedComponent = selectedComponent => {
    const { dispatch } = this.props;
    dispatch(initComponentConfig());
    dispatch(setSelectedComponent(selectedComponent));
  };

  handleChangeComponentLabels = (lng, event) => {
    const { dispatch } = this.props;
    let { componentLabels } = this.state;

    let labels = clonedeep(componentLabels);

    labels[lng] = event.target.value;

    this.setState({
      componentLabels: labels
    });
    dispatch(setSlideComponentLabels(labels));
    dispatch(addComponentLabel(labels));
  };
  handleSelectYearsNumber = year => {
    const { dispatch, annexeCategory } = this.props;
    let yearsNumber = {};
    dispatch(configNbrYear(year));
    if (annexeCategory == null) {
      yearsNumber = { nbrOfYears: year };
    } else {
      yearsNumber = {
        nbrOfYears: year,
        annexeAttachmentCategory: annexeCategory
      };
    }
    dispatch(addNumberOfYears(yearsNumber));
  };
  handleSelectAnnexeCategory = (
    category,
    isBarometerConfig = false,
    isTableConfig = false
  ) => {
    const {
      dispatch,
      minValue,
      maxValue,
      nbrOfYear,
      configComponent
    } = this.props;
    let cat = {};
    dispatch(addAnnexeCategory(category));
    if (isBarometerConfig) {
      if (
        configComponent.config.hasExplanation !== undefined &&
        configComponent.config.hasExplanation === true
      ) {
        cat = {
          minValue,
          maxValue,
          annexeAttachmentCategory: category,
          hasExplanation: true
        };
      } else {
        cat = {
          minValue,
          maxValue,
          annexeAttachmentCategory: category
        };
      }
      dispatch(addNumberOfYears(cat));
    } else if (isTableConfig) {
      if (
        configComponent.config.hasExplanation !== undefined &&
        configComponent.config.hasExplanation === true
      ) {
        cat = {
          nbrOfYears: nbrOfYear,
          annexeAttachmentCategory: category,
          hasExplanation: true
        };
      } else {
        cat = {
          nbrOfYears: nbrOfYear,
          annexeAttachmentCategory: category
        };
      }
      dispatch(addNumberOfYears(cat));
    } else if (isBarometerConfig === false && isTableConfig === false) {
      if (
        configComponent.config.hasExplanation !== undefined &&
        configComponent.config.hasExplanation === true
      ) {
        cat = {
          annexeAttachmentCategory: category,
          hasExplanation: true
        };
      } else {
        cat = {
          annexeAttachmentCategory: category
        };
      }
      dispatch(addNumberOfYears(cat));
    }
  };
  handleMaxValue = event => {
    const { dispatch, minValue, maxValue, annexeCategory } = this.props;
    dispatch(addMaxValue(event.target.value));
    if (annexeCategory == null) {
      dispatch(
        addNumberOfYears({
          maxValue,
          minValue
        })
      );
    } else {
      dispatch(
        addNumberOfYears({
          maxValue,
          minValue,
          annexeAttachmentCategory: annexeCategory
        })
      );
    }
  };
  handleMinValue = event => {
    const { dispatch, minValue, maxValue, annexeCategory } = this.props;
    dispatch(addMinValue(event.target.value));
    if (annexeCategory === null) {
      dispatch(
        addNumberOfYears({
          maxValue,
          minValue
        })
      );
    } else {
      dispatch(
        addNumberOfYears({
          maxValue,
          minValue,
          annexeAttachmentCategory: annexeCategory
        })
      );
    }
  };
  handleChangeComponentType = type => {
    const { dispatch } = this.props;
    let { componentLabels } = this.state;
    dispatch(addComponentType(type));
    let labels = clonedeep(componentLabels);
    labels = {
      fr: "",
      en: "",
      nl: ""
    };
    this.setState({
      componentLabels: labels
    });
  };
  handleLayoutChange = layout => {
    const { dispatch } = this.props;
    dispatch(setLayout(layout));
    this.setState({ edited: true });
  };
  handleAddSlideIndicator = (id, indicator) => {
    const { dispatch } = this.props;
    const {
      composition: { SlideIndicators }
    } = this.props;
    let newIndicator = SlideIndicators;

    newIndicator[id] = indicator;
    dispatch(setIndicators(newIndicator));
  };
  handleAddComponentIndicator = (id, indicator) => {
    const { dispatch } = this.props;
    const {
      configComponent: { indicators }
    } = this.props;
    let newIndicator = indicators;

    newIndicator[id] = indicator;
    dispatch(addComponentIndicator(newIndicator));
  };

  handleFondColorChange = color => {
    const { dispatch } = this.props;
    dispatch(setFondColor(color));
    dispatch(
      setBackgroundComponent(color === "#FFFFFF" ? "#F3FAFF" : "#FFFFFF")
    );
    this.setState({ edited: true });
  };

  handleChangeComponentBackgroundColor = color => {
    const { dispatch } = this.props;
    dispatch(setBackgroundComponent(color));
    dispatch(setFondColor(color === "#FFFFFF" ? "#F3FAFF" : "#FFFFFF"));
    this.setState({ edited: true });
  };

  handleRemoveComponent = selectedCase => {
    this.setState({ selectedCase: selectedCase });
    this.setState({ isOpenModalDelete: true });
  };

  handleUpdateComponent = (selectedCase, sideBar, selectedComponent) => {
    const { components, dispatch } = this.props;
    let { componentLabels } = this.state;
    dispatch(setSideBar(sideBar));
    dispatch(setSelectedComponent(selectedComponent));
    let componentUpdate = components[selectedCase];
    dispatch(setSelectedCase(selectedCase));
    dispatch(setComponent(componentUpdate));
    dispatch(setComponentAction("UPDATE"));

    let labels = clonedeep(componentLabels);
    labels = this.props.components[selectedCase].labels;
    this.setState({
      componentLabels: labels
    });
    // dispatch(addComponentIndicator(components[selectedCase].indicators));
  };

  handleConfirmUpdateComponent = selectedCase => {
    const { configComponent, components } = this.props;
    components[selectedCase] = configComponent;
    components[selectedCase].data = [];
    this.handleSaveComponentConfiguration(true);
  };
  handleAddComponent = () => {
    let {
      configComponent: { data, labels, config, indicators, type },
      components,
      dispatch,
      selectedCase
    } = this.props;
    if (components.length === 0) {
      components = {};
    }
    var firstPart = (Math.random() * 46656) | 0;
    var secondPart = (Math.random() * 46656) | 0;
    firstPart = ("0000" + firstPart.toString(36)).slice(-4);
    secondPart = ("0000" + secondPart.toString(36)).slice(-4);
    let date = Date.now();
    var result = firstPart + date + secondPart;
    let newComponent = components;
    newComponent[selectedCase] = {
      componentId: result,
      labels: labels,
      type: type,
      indicators: indicators,
      config: config,
      data: data
    };
    dispatch(addComponent(newComponent));

    this.setState({
      saveComponent: true
    });
  };

  handlerkeyPressed = (event, id = null, indicator) => {
    if (event.key === "Enter") {
      if (id === null) {
        this.handleSaveIndicatorExplanation(id, indicator);
      } else {
        this.updateIndicatorExplanation(id, indicator);
      }
    }
  };

  updateIndicatorExplanation = (id, target) => {
    const { dispatch, indicatorsExplanation } = this.props;
    let newIndicatorsExplanation = [...indicatorsExplanation];
    dispatch(setSelectedIndicatorExplanation(target));
    // eslint-disable-next-line array-callback-return
    newIndicatorsExplanation.map((explanation, i) => {
      if (explanation.id === id) {
        newIndicatorsExplanation[i].content = explanation.content;
      }
    });
    // dispatch(setSelectedComponent(componentId));
    dispatch(saveIndicatorsExplanation(id, target)).then(
      res => {
        onSuccess(res, {
          title: _("explanationUpdated"),
          body: "explanation updated"
        });
      },
      err => {
        onError(err.response.data.errors[0].message);
      }
    );
  };
  handleSaveIndicatorExplanation = (id, indicator) => {
    const { dispatch, indicatorsExplanation } = this.props;
    let newIndicatorsExplanation = [...indicatorsExplanation];
    dispatch(setSelectedIndicatorExplanation(indicator));
    dispatch(saveIndicatorsExplanation(id, indicator)).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: "explanation saved"
        });
        let response = res.value.data.data.IndicatorExplanation;
        newIndicatorsExplanation.push({
          id: response.id,
          owner: response.owner,
          target: response.target,
          content: response.content,
          createdAt: response.createdAt,
          updatedAt: response.updatedAt
        });
        dispatch(AddExplanation(newIndicatorsExplanation));
      },
      err => {
        onError(err.response.data.errors[0].message);
      }
    );
  };

  handleSaveSlideComposition = () => {
    const { dispatch } = this.props;
    let id = this.slideId ? this.slideId : this.props.slideId;
    dispatch(saveSlideComposition(id)).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: _("slideSaved")
        });
        setTimeout(() => {
          dispatch(push("/slides"));
        }, 500);
        dispatch(setSlideAction("compose"));
      },
      err => {
        onError(err.response.data.errors[0].message);
      }
    );
  };
  handleSaveComponentConfiguration = (isDelete = false) => {
    const { dispatch } = this.props;

    if (isDelete === false) {
      this.handleAddComponent();
    }
    let id = this.slideId ? this.slideId : this.props.slideId;
    dispatch(saveSlideComposition(id)).then(
      res => {
        dispatch(setSlideId(res.value.data.data[0]));
        dispatch(fetchSlide(res.value.data.data[0]));
        this.setState({ explanationModal: false });
      },
      err => {
        onError(err.response.data.errors[0].message);
      }
    );
  };
  handleCloseCompositionPage = () => {
    const { dispatch } = this.props;

    if (this.state.edited) {
      this.setState({ isOpenModal: true });
    } else {
      dispatch(push("/slides"));
    }
  };

  handleChangePrivacyState = event => {
    const { dispatch } = this.props;
    this.setState({ edited: true });
    dispatch(setSlideIsEditable(0));
    if (event.target.value == "private") {
      this.setState({
        privacyState: false
      });
      dispatch(setSlideCompositionIsPublic(false));
    } else {
      this.setState({
        privacyState: true
      });
      dispatch(setSlideCompositionIsPublic(true));
    }
  };

  onChangeIsEditable = () => {
    const {
      dispatch,
      composition: { isEditable }
    } = this.props;
    dispatch(setSlideIsEditable(isEditable ? 0 : 1));
    this.setState({ edited: true });
  };

  render() {
    const {
      fetching,
      fetched,
      saving,
      sideBar,
      dispatch,
      components,
      withoutHeader,
      composition: { isEditable, organizations },
      backOffice
    } = this.props;
    let {
      isOpenModal,
      isOpenModalDelete,
      selectedCase,
      saveComponent,
      privacyState
    } = this.state;
    return (
      <div>
        <SimplePageHeader
          closePage={this.handleCloseCompositionPage}
          title={_("slideComposition")}
          primaryButton={{
            label: _("save"),
            action: this.handleSaveSlideComposition,
            saving: saving,
            isDisabled: this.slideId ? false : !saveComponent
          }}
          secondaryButton={{
            label: _("view"),
            action: this.handleDisplaySlideModal,
            saving: saving,
            isDisabled: !this.props.slideFetched,
            icon: "EyeIcon"
          }}
        />
        {fetching && (
          <div className={styles.ripple_loading}>
            <img src={"/img/Ripple-1s-150px.svg"} alt="" />
          </div>
        )}
        {fetched && (
          <div>
            {!backOffice && (
              <div className={styles.crosssharing_container}>
                <span> {_("visibility")} :</span>
                <div className={styles.visibility_options}>
                  <label
                    className={styles.container}
                    onChange={this.handleChangePrivacyState}
                  >
                    <input
                      type="radio"
                      checked={!privacyState ? "checked" : null}
                      name="radio"
                      value="private"
                      disabled={!!(organizations && organizations.length > 0)}
                    />
                    <span className={styles.checkmark} />
                    <span className={styles.labels_option}>{_("private")}</span>
                  </label>
                  <div className={styles.separator} />
                  <label
                    className={styles.container}
                    onChange={this.handleChangePrivacyState}
                  >
                    <input
                      type="radio"
                      checked={privacyState ? "checked" : null}
                      name="radio"
                      value="public"
                      disabled={!!(organizations && organizations.length > 0)}
                    />
                    <span className={styles.checkmark} />
                    <span className={styles.labels_option}>
                      {_("sharedWithCommunity")}
                    </span>
                  </label>
                </div>
                {privacyState ? (
                  <div
                    className={classnames(
                      styles.config_check,
                      withoutHeader ? styles.without_header : ""
                    )}
                  >
                    <div>
                      <span className={styles.sub_title}>
                        <Tooltip
                          placement="top"
                          title={_("slideEditableInfos")}
                        >
                          <img
                            data-for="info__undefined"
                            data-tip=""
                            className={styles.comment_icon}
                            src="/img/icons/info.svg"
                            alt=""
                          />{" "}
                        </Tooltip>
                        {_("editableTemplate")}
                      </span>
                    </div>
                    <Switch
                      className={styles.switch}
                      checked={isEditable}
                      onChange={() => this.onChangeIsEditable()}
                      disabled={!!(organizations && organizations.length > 0)}
                    />
                  </div>
                ) : null}
              </div>
            )}
            <div
              className={classnames(
                styles.left_side,
                withoutHeader ? styles.without_header : ""
              )}
            >
              <SlideDisposition
                Slide={this.props.composition}
                HandleRemoveComponent={this.handleRemoveComponent}
                HandleUpdateComponent={this.handleUpdateComponent}
                comments={this.props.comments}
              />
            </div>

            <ModalConfirm
              type={"return"}
              isOpen={isOpenModal}
              onCancel={() => this.setState({ isOpenModal: false })}
              onConfirm={() => {
                dispatch(push("/slides"));
              }}
              inProcess={false}
              actionFailed={false}
              title={_("exitConfirm")}
              text={_("cancelConfirmContent")}
              labelNo={_("cancel")}
              labelYes={_("exit")}
              labelError={"Error"}
            />
            <ModalConfirm
              type={"delete"}
              isOpen={isOpenModalDelete}
              onCancel={() => this.setState({ isOpenModalDelete: false })}
              onConfirm={() => {
                delete components[selectedCase];
                this.handleSaveComponentConfiguration(true);
                this.setState({ isOpenModalDelete: false });
              }}
              inProcess={false}
              actionFailed={false}
              title={_("deleteConfirm")}
              text={_("deleteComponentConfirm")}
              labelNo={_("cancel")}
              labelYes={_("delete")}
              labelError={"Error"}
            />
            <div className={styles.right_side}>
              {sideBar === "slideConfiguration" && (
                <SlideConfigurationPage
                  HandleInputChange={this.handlerInputChange}
                  HandleLayoutChange={this.handleLayoutChange}
                  handleChangeFondColor={this.handleFondColorChange}
                  handleChangeComponentBackgroundColor={
                    this.handleChangeComponentBackgroundColor
                  }
                  colorsConfig={this.props.colorsConfig}
                />
              )}
              {sideBar === "ComponentConfig" && (
                <ComponentConfiguration
                  HandleSaveComponentConfig={
                    this.handleSaveComponentConfiguration
                  }
                  handleUpdateComponent={this.handleConfirmUpdateComponent}
                  HandleChangeComponentLabels={this.handleChangeComponentLabels}
                  HandleAddComponentIndicator={this.handleAddComponentIndicator}
                  HandleSelectAnnexeCategory={this.handleSelectAnnexeCategory}
                  HandleAddSlideIndicator={this.handleAddSlideIndicator}
                  handlerIndicatorsExplanation={
                    this.handlerIndicatorsExplanation
                  }
                />
              )}
              {sideBar === "NumberOfYearsComponentConfig" && (
                <NumberOfYearsComponentConfiguration
                  HandleSaveComponentConfig={
                    this.handleSaveComponentConfiguration
                  }
                  handleUpdateComponent={this.handleConfirmUpdateComponent}
                  HandleChangeComponentLabels={this.handleChangeComponentLabels}
                  HandleSelectYearsNumber={this.handleSelectYearsNumber}
                  HandleAddComponentIndicator={this.handleAddComponentIndicator}
                  HandleChangeSideBar={this.handleChangeSideBar}
                  HandleSelectAnnexeCategory={this.handleSelectAnnexeCategory}
                  HandleAddSlideIndicator={this.handleAddSlideIndicator}
                  handlerIndicatorsExplanation={
                    this.handlerIndicatorsExplanation
                  }
                />
              )}
              {sideBar === "MultiIndicatorComponentConfig" && (
                <MultiIndicatorComponentConfiguration
                  HandleSaveComponentConfig={
                    this.handleSaveComponentConfiguration
                  }
                  handleUpdateComponent={this.handleConfirmUpdateComponent}
                  HandleChangeComponentLabels={this.handleChangeComponentLabels}
                  HandleAddComponentIndicator={this.handleAddComponentIndicator}
                  HandleChangeSideBar={this.handleChangeSideBar}
                  HandleSelectAnnexeCategory={this.handleSelectAnnexeCategory}
                  HandleAddSlideIndicator={this.handleAddSlideIndicator}
                  handlerIndicatorsExplanation={
                    this.handlerIndicatorsExplanation
                  }
                />
              )}
              {sideBar === "BarometerConfig" && (
                <BarometerConfiguration
                  HandleMaxValue={this.handleMaxValue}
                  HandleMinValue={this.handleMinValue}
                  HandleSaveComponentConfig={
                    this.handleSaveComponentConfiguration
                  }
                  handleUpdateComponent={this.handleConfirmUpdateComponent}
                  HandleChangeComponentLabels={this.handleChangeComponentLabels}
                  HandleAddComponentIndicator={this.handleAddComponentIndicator}
                  HandleChangeSideBar={this.handleChangeSideBar}
                  HandleSelectAnnexeCategory={this.handleSelectAnnexeCategory}
                  HandleAddSlideIndicator={this.handleAddSlideIndicator}
                  handlerIndicatorsExplanation={
                    this.handlerIndicatorsExplanation
                  }
                />
              )}
              {sideBar === "ComponentList" && (
                <ComponentList
                  HandleChangeComponentType={this.handleChangeComponentType}
                />
              )}
              <ShowSlideModal
                isVisible={this.state.showSlideModal}
                handleCancelModal={this.handleCancelShowSlideModal}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  fetching:
    state.indicators.fetching ||
    state.preparePresentation.fetching ||
    state.indicatorsExplanation.fetching,
  fetched:
    state.indicators.fetched &&
    state.preparePresentation.fetched &&
    state.indicatorsExplanation.fetched,
  slideFetched: state.slideComposition.fetchSlide.fetched,
  fetchSlides: state.slideList.fetched,
  saving: state.slideComposition.saving,
  error: state.slideComposition.error,
  composition: state.slideComposition.composition,
  components: state.slideComposition.composition.layout.components,
  layout: state.slideComposition.composition.layout,
  sideBar: state.slideComposition.composition.sideBar,
  lng: state.params.lng,
  slideId: state.slideComposition.composition.slideId,
  selectedCase: state.slideComposition.composition.layout.selectedCase,
  configComponent: state.slideComposition.componentConfig,
  minValue: state.slideComposition.minValue,
  maxValue: state.slideComposition.maxValue,
  colorsConfig: state.slideComposition.composition.layout.config,
  annexeCategory: state.slideComposition.annexeCategory,
  nbrOfYear: state.slideComposition.nbrOfYears,
  slideUpdate: state.slideComposition.slide.label,
  slideAction: state.slideComposition.slideAction,
  organizationUen: state.auth.currentOrganization.uen,
  comments: state.preparePresentation.items.comments,
  indicatorsExplanation: state.indicatorsExplanation.items,
  slideIndicators: state.slideComposition.composition.SlideIndicators,
  suggestions: state.indicators.suggestions.items,
  withoutHeader: state.auth.withoutHeader,
  backOffice: state.params.backOffice
});

export default connect(mapStateToProps)(SlideCompositionPage);



// WEBPACK FOOTER //
// ./src/components/SlideComposition/SlideCompositionPage.js